import { useCareTeam } from './useCareTeam';
import { useEffect } from 'react';
import { gql } from '@apollo/client';
import { PatientCareTeamMember } from '../../type';
import { graphql } from '@xolv-mybrightlink/common';

type CareTeamMemberResponse = {
  supervisors: PatientCareTeamMember[];
};

export const useFetchCareTeamMembers = () => {
  const [store, dispatch] = useCareTeam();
  const isLoading = store === 'LOADING';
  useEffect(() => {
    const fetch = async () => {
      if (isLoading) {
        return;
      }
      const query = gql`
        query supervisors {
          supervisors {
            patientGuid
            careTeamMembers {
              sfId
              firstName
              lastName
              role
              providerSfId
            }
          }
        }
      `;
      const { data } = await graphql.query<CareTeamMemberResponse>({ query });
      dispatch({
        type: 'CARE_TEAM_MEMBER_UPDATE',
        patientCareTeamMembers: data.supervisors,
      });
    };
    fetch();
  }, [isLoading, dispatch]);
};
